const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    INTERNAL_API_URL: 'https://m1wk9jgj5b.execute-api.ap-southeast-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://3wfo7v1z34.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.au.forwood.one'
  },
  configurationService: {
    URL: 'https://config.au.forwood.one',
    WEBSOCKET: 'wss://l2a5ttj1n4.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
};

export default config;